"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * IScoreGolfPlus Development
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: 1.1.56-production
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.HasPlayerSkippedIntroductionVideoResponseToJSON = exports.HasPlayerSkippedIntroductionVideoResponseFromJSONTyped = exports.HasPlayerSkippedIntroductionVideoResponseFromJSON = void 0;
function HasPlayerSkippedIntroductionVideoResponseFromJSON(json) {
    return HasPlayerSkippedIntroductionVideoResponseFromJSONTyped(json, false);
}
exports.HasPlayerSkippedIntroductionVideoResponseFromJSON = HasPlayerSkippedIntroductionVideoResponseFromJSON;
function HasPlayerSkippedIntroductionVideoResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'skipIntroductionVideo': json['skipIntroductionVideo'],
    };
}
exports.HasPlayerSkippedIntroductionVideoResponseFromJSONTyped = HasPlayerSkippedIntroductionVideoResponseFromJSONTyped;
function HasPlayerSkippedIntroductionVideoResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'skipIntroductionVideo': value.skipIntroductionVideo,
    };
}
exports.HasPlayerSkippedIntroductionVideoResponseToJSON = HasPlayerSkippedIntroductionVideoResponseToJSON;
